import type { QuotationWorkflowId } from '@e-socna/data-layer';

type QuotationInfoShape = Readonly<{ workflowId: string; stateId: string }>;

type QuotationWorkflowsIdMapShape = Readonly<
  Record<
    string,
    | Readonly<{
        stateMachine: readonly Readonly<{
          stateId: string;
          settings: Readonly<{ areOptionGroupsSelectionEditable: boolean }>;
        }>[];
      }>
    | undefined
  >
>;

// The option choice of the pricing can be changed while the state of the
// quotation sent to the client allows it (always before its quotation).
export const isOptionGroupsSelectionEditable = ({
  quotationInfo,
  quotationWorkflowsIdMap,
}: Readonly<{
  quotationInfo: QuotationInfoShape | null | undefined;
  quotationWorkflowsIdMap: QuotationWorkflowsIdMapShape;
}>): boolean =>
  !quotationInfo ||
  !!quotationWorkflowsIdMap[
    quotationInfo.workflowId as QuotationWorkflowId
  ]?.stateMachine.find((node) => node.stateId === quotationInfo.stateId)
    ?.settings.areOptionGroupsSelectionEditable;
